import React from "react";

import SubTitle from "../../components/SubTitle";
import {FormContents, FormSection} from "../../styledComponents/StyledCreateForm";
import MWCaption from "../../components/MWCaption";

import {Link} from "react-router-dom";
import {List, ListItem, ListItemButton, ListItemIcon, Divider} from "@mui/material";

import MapsHomeWorkIcon from "@mui/icons-material/MapsHomeWork";
import AlignVerticalCenterIcon from "@mui/icons-material/AlignVerticalCenter";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import AutoAwesomeMosaicIcon from "@mui/icons-material/AutoAwesomeMosaic";
import CalendarViewDayIcon from "@mui/icons-material/CalendarViewDay";
import CenterFocusWeakIcon from "@mui/icons-material/CenterFocusWeak";
import HeightIcon from "@mui/icons-material/Height";
import ConstructionIcon from "@mui/icons-material/Construction";
const ConfigureDangerEvaluation = () => {
  return (
    <React.Fragment>
      <SubTitle subTitle="작업위험성 평가관리" />

      <FormSection>
        <MWCaption title="유해위험요인 설정" color="#546E7A" icon="" />
        <FormContents>
          <List>
            <ListItem>
              <ListItemButton>
                <ListItemIcon>
                  <MapsHomeWorkIcon color="secondary" />
                </ListItemIcon>
                <Link to={`/Permission/CheckItemList/${0}`}>일반작업</Link>
              </ListItemButton>
            </ListItem>
            <Divider light />
            <ListItem>
              <ListItemButton>
                <ListItemIcon>
                  <AlignVerticalCenterIcon color="secondary" />
                </ListItemIcon>
                <Link to={`/Permission/CheckItemList/${1}`}>화기작업</Link>
              </ListItemButton>
            </ListItem>
            <Divider light />
            <ListItem>
              <ListItemButton>
                <ListItemIcon>
                  <AnalyticsIcon color="secondary" />
                </ListItemIcon>
                <Link to={`/Permission/CheckItemList/${2}`}>밀페작업</Link>
              </ListItemButton>
            </ListItem>
            <Divider light />
            <ListItem>
              <ListItemButton>
                <ListItemIcon>
                  <AutoAwesomeMosaicIcon color="secondary" />
                </ListItemIcon>
                <Link to={`/Permission/CheckItemList/${3}`}>정전작업</Link>
              </ListItemButton>
            </ListItem>
            <Divider light />
            <ListItem>
              <ListItemButton>
                <ListItemIcon>
                  <CalendarViewDayIcon color="secondary" />
                </ListItemIcon>
                <Link to={`/Permission/CheckItemList/${4}`}>굴착작업</Link>
              </ListItemButton>
            </ListItem>
            <Divider light />
            <ListItem>
              <ListItemButton>
                <ListItemIcon>
                  <CenterFocusWeakIcon color="secondary" />
                </ListItemIcon>
                <Link to={`/Permission/CheckItemList/${5}`}>방사선</Link>
              </ListItemButton>
            </ListItem>
            <Divider light />
            <ListItem>
              <ListItemButton>
                <ListItemIcon>
                  <HeightIcon color="secondary" />
                </ListItemIcon>
                <Link to={`/Permission/CheckItemList/${6}`}>고소작업</Link>
              </ListItemButton>
            </ListItem>
            <Divider light />
            <ListItem>
              <ListItemButton>
                <ListItemIcon>
                  <ConstructionIcon color="secondary" />
                </ListItemIcon>
                <Link to={`/Permission/CheckItemList/${7}`}>중장비</Link>
              </ListItemButton>
            </ListItem>
            <Divider light />
          </List>
        </FormContents>
      </FormSection>
    </React.Fragment>
  );
};

export default ConfigureDangerEvaluation;
